import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { update_page_meta } from "../../actions/page/header";
import { listStores } from "../../actions/store/store";
import PageHeader from "../../components/page/PageHeader";
import { Modal } from "bootstrap";
import StoreModal from "./StoreModal";
import { Link, useNavigate } from "react-router-dom";
import { HomePageURL } from "../../assets/const";
// import OrganizationScroller from "../../components/OrganizationScroller";
import { useSelectedOrganizations } from "../../reducers/accounts/user";

const StoreList = ({ update_page_meta }) => {
  update_page_meta({
    title: "Stores",
    description: "All available stores",
  });
  // const selectedOrganizations = useSelectedOrganizations();
  const [perPage, setPerPage] = useState(9);
  const [Stores, setStores] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [fetching, setFetching] = useState(false);
  const bottomElementRef = useRef();

  useEffect(() => {
    const fetchMore = async () => {
      if (page > totalPages || fetching) return;
      try {
        setFetching(true);
        const response = await listStores(page, perPage);
        if (response.success) {
          setStores((prevStores) => {
            if (page === 1) {
              return response.stores; // Set the initial stores
            } else {
              return [...prevStores, ...response.stores]; // Append new stores
            }
          });
          setTotalPages(response.num_pages);
          setPage(page + 1);
        }
      } catch (error) {
        console.error("Error fetching more products:", error);
      } finally {
        setFetching(false);
      }
    };

    const options = {
      root: null, // viewport
      rootMargin: "0px",
      threshold: 0.1, // When 10% of the element is visible, trigger the callback
    };

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        fetchMore();
      }
    }, options);

    const bottomElement = bottomElementRef.current;

    if (bottomElement) {
      observer.observe(bottomElement);
    }

    return () => {
      if (bottomElement) {
        observer.unobserve(bottomElement);
      }
    };
  }, [bottomElementRef, page, totalPages, fetching]);
  const [Store, setStore] = useState(null);
  const opencreatestoremodal = (e) => {
    setStore({
      name: "",
      phone: "",
      email: "",
      gst: "",
      gst_cert: null,
    });
    let storemodal = Modal.getOrCreateInstance(
      document.getElementById("storemodal")
    );
    storemodal.show();
  };
  let navigate = useNavigate();
  const rows = Stores?.map((store, index) => {
    return (
      <tr key={index}>
        <td></td>
        <td>{store?.name}</td>
        <td>{store?.suborganization?.name}</td>
        <td>{store?.created_by?.full_name}</td>
        <td>
          {store?.is_approved ? (
            <span className="text-success">Approved</span>
          ) : (
            <span className="text-danger">Not Approved</span>
          )}
        </td>
        <td
          className="cursor-pointer"
          onClick={() =>
            navigate(`${HomePageURL}/stores/${store?.slug}/`, {
              replace: false,
            })
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            className="feather feather-arrow-right"
          >
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </td>
      </tr>
    );
  });
  return (
    <>
      <PageHeader title="Stores" />
      <div className="row layout-top-spacing" id="cancel-row">
        <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
          <Link
            className="btn btn-primary mb-2 me-2"
            to={`${HomePageURL}/stores-under-review/`}
          >
            Stores Under Review
          </Link>
        </div>
        <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
          <div className="widget-content widget-content-area br-6">
            {/* <OrganizationScroller /> */}
            <div className="table-responsive mb-4 mt-4">
              <table
                id="zero-config"
                className="table table-hover"
                style={{ width: "100%" }}
              >
                <thead>
                  <tr>
                    <th className="no-content"></th>
                    <th>Name</th>
                    <th>Suborganization</th>
                    <th>Created By</th>
                    <th>Approval Status</th>
                    <th className="no-content"></th>
                  </tr>
                </thead>
                <tbody>{rows}</tbody>
                <tfoot ref={bottomElementRef}>
                  {/* <td colSpan={6} className="p-3" >
                                        {
                                            Page<numPages ? 
                                            <span role="button" onClick={() => setPage(Page+1)}>
                                                Load More
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                                            </span> :
                                            <p>You are all caught up</p>
                                        }
                                    </td> */}
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
      <StoreModal Store={Store} setStore={setStore} />
    </>
  );
};

export default connect(null, { update_page_meta })(StoreList);
